/* eslint no-mixed-operators: "off" */

const galleryDomain = f => (state, ...args) =>
  state && state.gallery && f(state.gallery, ...args) || f(null, ...args)

export const getThumbnails = galleryDomain(state => {
  if (state && state.persons) {
    return Object.keys(state.persons).map((slug) => {
      return ['name', 'slug', 'thumbnail', 'icon', 'iconAlt'].reduce(
        (thumbnails, key) => ({
          ...thumbnails,
          [key]: state.persons[slug][key],
        }),
        {}
      )
    })
  }
  return null
})

export const getPersonDetails = galleryDomain((state, params) => {
  if (state && state.persons) {
    if (params && params.slug) {
      return state.persons[params.slug]
    } else if (state.last_person_slug) {
      return state.persons[state.last_person_slug]
    }
  }
  return null
})

export const isAuthenticated = galleryDomain(state =>
  state
  && state.authenticated
  && state.authenticated === true
  || false
)

export const isGalleryLoading = galleryDomain(state =>
  state
  && state.first_load === true
  || false
)

export const hasErrors = galleryDomain(state =>
  state
  && state.displayFormErrors
  && state.displayFormErrors !== false
  || false
)

export const hasPersons = galleryDomain(state =>
  state
  && state.persons
  && Object.keys(state.persons).length > 0
  || false
)

export const getScrollPosition = galleryDomain(state =>
    state
    && state.scrollPosition
    || 0
)



// WEBPACK FOOTER //
// ./src/gallery/selectors.js